<template>
  <div id="shopping-aftercustomer">
    <div class="wrap">
      <div class="wrap_zh">
        <div class="shopping-title">
          <div class="shopping-title_name fl">售后中心</div>
        </div>
      </div>
    </div>
    <div class="wrap">
      <div class="wrap_zh shopping-orders">
        <div class="shopping-orders-headlist fl">
          <ul>
            <li :class="orderListIndex == 0 && 'on'" @click="operaOrderIndexClick(0)">售后单</li>
            <li :class="orderListIndex == 1 && 'on'" @click="operaOrderIndexClick(1)">补发单</li>
            <li :class="orderListIndex == 2 && 'on'" @click="operaOrderIndexClick(2)">退货单</li>
          </ul>
        </div>
        <div class="shopping-orders-body fl">
          <div class="shopping-orders-bodytr fl" v-for="(item,index) in orderList" :key="index">
            <div class="shopping-orders-body_tr fl">
              <span>
                下单时间：
                <font>{{item.createDate}}</font>
              </span>
              <span>
                订单编号：
                <font>{{item.orderNo}}</font>
              </span>
            </div>
            <div class="shopping-orders-body-td fl">
              <div class="shopping-orders-body_goods fl">
                <el-popover
                  placement="bottom"
                  trigger="hover"
                  v-for="(val,num) in item.productInfoENTList"
                  :key="num"
                  v-if="num < 6"
                >
                  <div class="shopping-order-img-show">
                    <div class="shopping-detail_goods-find">
                      <div class="shopping-detail_goods-find-img fl">
                        <img :src="val.productImgUrl">
                      </div>
                      <dl>
                        <dt>
                          {{val.productName}}
                          <font>（{{val.productSpec}}）</font>
                        </dt>
                        <dd>
                          <font
                            v-for="(s,n) in val.productLabelENTList"
                            :key="s.id"
                            v-if="n < 3"
                          >{{s.labelName}}</font>
                        </dd>
                      </dl>
                      <div class="shopping-numbers">×{{val.quantity}}</div>
                    </div>
                  </div>
                  <img :src="val.productImgUrl" class="shopping-goods_img" slot="reference">
                </el-popover>
                <div class="shopping-my-orders-info">
                  <font v-if="item.productInfoENTList.length > 6">…</font>
                  共计{{item.productInfoENTList.length}}件商品
                </div>
              </div>
              <div class="shopping-orders-body_type shopping-center fl">
                <font>{{item.orderStatusName}}</font>
              </div>
              <div class="shopping-orders-body_price shopping-center fl">
                <font>¥ {{item.totalAmount}}</font>
              </div>
              <div class="shopping-orders-body_doing fl">
                <div class="shopping-order-doing fl" v-if="item.orderStatus == 8">
                  <el-button
                    type="danger"
                    class="shopping-set_sel-btn_s"
                    @click="operaConfirm('confirmAfterSaleCanel',item)"
                    v-if="item.orderStatus == '8'"
                  >取消售后</el-button>
                </div>

                <div
                  class="shopping-order-doing fl"
                  v-if="item.orderStatus == 4 && pramsAfter.orderType == 3"
                >
                  <el-button
                    type="danger"
                    class="shopping-set_sel-btn_s"
                    @click="operaConfirm('confirmGetGoods',item)"
                  >确认收货</el-button>
                </div>

                <div
                  class="shopping-order-doing fl"
                  v-if="item.orderStatus == 3 && pramsAfter.orderType == 4"
                >
                  <el-button
                    type="danger"
                    class="shopping-set_sel-btn_s"
                    @click="operaConfirm('confirmDeliverGoods',item)"
                  >退货</el-button>
                </div>
                <div class="shopping-order-doing fl">
                  <router-link
                    class="on"
                    :to="'/shoppingMall/shoppingOrderDetail/'+item.id"
                    v-if="pramsAfter.orderType == 0"
                  >查看详情</router-link>
                </div>
                <div class="shopping-order-doing fl">
                  <router-link
                    class="on"
                    :to="'/shoppingMall/shoppingAfterDetail/'+item.id"
                    v-if="pramsAfter.orderType != 0"
                  >查看详情</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="wrap">
      <div class="wrap_zh shopping-orders-pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="prams.pageSize"
          :total="totalCount"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
    <!-- model弹层 -->
    <shoppingModel :visibleModel="visibleModel" @operaCanel="operaCanel" @operaSure="operaSure"/>
  </div>
</template>
<script type="text/javascript">
import shoppingModel from "@/components/shoppingMall/shoppingModel";
import { selectAfterSaleOrders, selectReplaceAndReturnOrders } from "@/api";
import shoppingPublic from "@/assets/js/shoppingPublic";
export default {
  name: "shopping-aftercustomer",
  components: {
    shoppingModel
  },
  data() {
    return {
      orderList: [],
      prams: {
        pageSize: 8,
        pageNumber: 1,
        orderSystem: this.$store.state.userInfo.brandId
      },

      pramsAfter: {
        orderType: 0,
        pageSize: 8,
        pageNumber: 1,
        orderSystem: this.$store.state.userInfo.brandId
      },
      totalCount: 0,
      orderListIndex: 0,
      visibleModel: ""
    };
  },
  created() {
    this.operaSelectOrder();
  },
  methods: {
    operaSelectOrder() {
      selectAfterSaleOrders(this.prams).then(res => {
        this.orderList = res.obj.rows;
        this.totalCount = res.obj.total;
        this.$store.commit('SEARCH_SHOPPING_GOODS','');
      });
    },

    operaSelectAfterOrder() {
      selectReplaceAndReturnOrders(this.pramsAfter).then(res => {
        this.orderList = res.obj.rows;
        this.totalCount = res.obj.total;
      });
    },

    handleCurrentChange(val) {
      if (this.pramsAfter.orderType == 0) {
        this.prams.pageNumber = val;
        this.operaSelectOrder();
      } else {
        this.pramsAfter.pageNumber = val;
        this.operaSelectAfterOrder();
      }
    },
    operaOrderIndexClick(val) {
      this.orderListIndex = val;
      this.pramsAfter.orderType = 0;
      if (val == 0) {
        this.handleCurrentChange(1);
      } else if (val == 1) {
        this.pramsAfter.orderType = 3;
        this.handleCurrentChange(1);
      } else if (val == 2) {
        this.pramsAfter.orderType = 4;
        this.handleCurrentChange(1);
      }
    },
    //confirm
    operaConfirm(val, item) {
      let visibleModels = {};
      visibleModels.id = item.id;
      visibleModels.modelType = val;
      if(val == 'confirmGetGoods' || val == 'confirmDeliverGoods'){
        visibleModels.orderType = 2;
      }
      this.visibleModel = JSON.stringify(visibleModels);
    },
    //再次购买
    operaAgainBuy(val) {
      let goodsInfo = val.productInfoENTList;
      goodsInfo.forEach((val, index, arr) => {
        val.subtotal = shoppingPublic.computePrice(val.price * val.quantity, 2);
        val.productLabels = val.productLabelENTList;
      });
      console.log(goodsInfo);
      sessionStorage.setItem("submitArr", JSON.stringify(goodsInfo));
      this.$router.push("/shoppingMall/shoppingSubmit");
    },

    //model公用返回方法
    operaSure(val) {
      if (val == 'confirmDeliverGoods') {
        this.pramsAfter.orderType = 4;
        this.handleCurrentChange(1);
      } else if (val == 'confirmGetGoods') {
        this.pramsAfter.orderType = 3;
        this.handleCurrentChange(1);
      } else if (val == 2) {
        this.handleCurrentChange(1);
      }
      this.visibleModel = "";
      this.operaSelectOrder();
    },
    operaCanel(val) {
      this.visibleModel = "";
    }
  }
};
</script>
<style type="text/css">
.shopping-orders {
  margin-top: 30px;
  background: #ffffff;
}
.shopping-orders-headlist {
  padding-left: 60px;
  width: 100%;
  height: 80px;
  line-height: 80px;
  font-size: 15px;
  color: #444444;
  border-bottom: 1px solid #d5d9e3;
}
.shopping-orders-headlist ul {
  float: left;
  width: 100%;
}

.shopping-orders-headlist ul li {
  float: left;
  width: 120px;
  text-align: center;
  cursor: pointer;
}

.shopping-orders-headlist ul li.on {
  width: 120px;
  height: 78px;
  border-bottom: 4px solid #f83c57;
}
.shopping-orders-body {
  width: 100%;
}
.shopping-orders-bodytr {
  width: 100%;
}
.shopping-orders-body_tr {
  padding-left: 41px;
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: #eff1f5;
}
.shopping-orders-body_tr span {
  margin-right: 24px;
  font-size: 12px;
  color: #666666;
}
.shopping-orders-body-td {
  display: flex;
  width: 100%;
  height: 100px;
  font-size: 14px;
  color: #444444;
}
.shopping-center {
  text-align: center;
}
.shopping-orders-body_goods {
  display: flex;
  padding-left: 20px;
  flex: 1;
  flex-direction: row;
  height: 100px;
  align-items: center;
}
.shopping-orders-body_type {
  display: flex;
  flex-direction: column;
  width: 180px;
  height: 100px;
  justify-content: center;
}
.shopping-orders-body_price {
  display: flex;
  flex-direction: column;
  width: 180px;
  height: 100px;
  justify-content: center;
}
.shopping-orders-body_doing {
  display: flex;
  flex-direction: column;
  width: 180px;
  height: 100px;
  justify-content: center;
}
.shopping-orders-body_doing .el-button {
  font-size: 12px;
  padding: 0;
}
.shopping-orders-body_type font {
  color: #f83c57;
}
.shopping-order-doing {
  margin-top: 5px;
  margin-bottom: 5px;
  width: 100%;
  font-size: 12px;
  text-align: center;
}
.shopping-order-doing .shopping-set_sel-btn_s {
  padding: 0;
  width: 80px;
  height: 32px;
  font-size: 12px;
  color: #ffffff;
  background: #f83c57;
  border-radius: 5px !important;
}
.shopping-order-doing .el-button--text {
  color: #444444;
}

.shopping-order-img-show {
  width: 340px;
}
.shopping-goods_img {
  margin-left: 27px;
  width: 52px;
  height: 32px;
  cursor: pointer;
}
.shopping-order-img-show .shopping-detail_goods-find {
  padding-left: 0px;
}
.shopping-numbers {
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 14px;
  color: #666666;
}
.shopping-my-orders-info {
  margin-left: 24px;
  font-size: 14px;
  color: #444444;
}
.shopping-orders-pagination {
  margin-top: 40px;
  text-align: center;
}
.shopping-orders-pagination
  .el-pagination.is-background
  .el-pager
  li:not(.disabled).active {
  background-color: #f83c57 !important;
}
.shopping-orders-pagination .el-pagination.is-background .btn-next,
.shopping-orders-pagination .el-pagination.is-background .btn-prev,
.shopping-orders-pagination .el-pagination.is-background .el-pager li {
  background-color: #ebecef;
}
</style>


// WEBPACK FOOTER //
// src/components/shoppingMall/shoppingAfterCustomer.vue